import { ElementViewerDataType } from 'components/element-viewer/index';
import React, { useLayoutEffect, useState } from 'react';
import HeadingElementData from 'components/element-viewer/HeadingElementData';
import ControlsPanel from 'components/element-viewer/ControlsPanel';
import { Box, Card, CardContent, CardHeader, Skeleton, Stack } from '@mui/material';
import TopControlsWrapper from 'components/element-viewer/common/TopControlsWrapper';
import { ElementEmbeddingType } from 'components/element-viewer/IFrameElementViewer';
import LoadingPlaceholder from 'components/common/loading-placeholder/LoadingPlaceholder';

export default function ViewerPlaceholder({
    shortElementInfo,
    handleFavoritesChange,
    embeddingType,
}: {
    shortElementInfo?: ElementViewerDataType;
    handleFavoritesChange: () => void;
    embeddingType?: ElementEmbeddingType;
}) {
    if (embeddingType == 'tile') {
        return <LoadingPlaceholder />;
    }

    if (embeddingType == 'short' || embeddingType == 'preview') {
        return (
            <Stack sx={{ height: '100%' }} direction={'column'} justifyContent={'stretch'}>
                <Skeleton sx={{ height: '100%', width: '100%' }} animation="wave" variant="rectangular" />
            </Stack>
        );
    }

    return (
        <Stack sx={{ height: '100%' }} direction={'column'} justifyContent={'stretch'}>
            <TopControlsWrapper>
                {shortElementInfo ? (
                    <>
                        <HeadingElementData element={shortElementInfo.elementData} />
                        <ControlsPanel
                            element={shortElementInfo.elementData}
                            segmentValueId={shortElementInfo.segmentValueId}
                            alertStatus={shortElementInfo.alertStatus}
                            onFavoritesChange={handleFavoritesChange}
                        />
                    </>
                ) : (
                    <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                        <Box sx={{ width: '100%', height: '44px' }}>
                            <Skeleton height="28px" width="35%" />
                            <Skeleton width="45%" />
                        </Box>
                        <Box
                            sx={{ width: '100%', height: '44px', display: 'flex', justifyContent: 'flex-end', gap: 1 }}
                        >
                            <Skeleton height="38px" width="138px" />
                            <Skeleton height="38px" width="138px" />
                            <Skeleton height="38px" width="62px" />
                        </Box>
                    </Stack>
                )}
            </TopControlsWrapper>
            <Box sx={{ position: 'relative', flexGrow: 1 }}>
                <Card sx={{ width: '100%', height: '100%' }}>
                    <Skeleton sx={{ height: '70%', margin: 2 }} animation="wave" variant="rectangular" />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <CardHeader
                            sx={{ width: '50%' }}
                            avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
                            title={<Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />}
                            subheader={<Skeleton animation="wave" height={10} width="40%" />}
                        />
                        <CardContent sx={{ width: '50%' }}>
                            <React.Fragment>
                                <Skeleton animation="wave" height={18} />
                                <Skeleton animation="wave" height={18} />
                                <Skeleton animation="wave" height={18} />
                                <Skeleton animation="wave" height={18} width={'75%'} />
                            </React.Fragment>
                        </CardContent>
                    </Box>
                </Card>
                <LoadingPlaceholder
                    sx={{
                        position: 'absolute',
                    }}
                />
            </Box>
        </Stack>
    );
}
